module.exports = __webpack_public_path__ + "img/face.548da217.png";